/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from "@wordpress/block-editor";

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save({ attributes }) {
	const {
		separators,
		tagline,
		taglineInput,
		color,
		separatorWidth,
		separatorHeight,
		taglineFontSize,
		taglineSpacing,
		taglineColor,
		textAlign,
		taglineAlign,
		prefixColor,
		separatorGap,
		svgInput,
	} = attributes;

	const getStyles = () => ({
		position: 'relative',
		'--text-align': taglineAlign,
		'--separator-width': `${separatorWidth}% `,
		'--separator-gap': `${separatorGap}px`,
		'--separator-color': color,
		'--separator-height': `${separatorHeight}px`,
		'--tagline-size': `${taglineFontSize}px`,
		'--tagline-spacing': `${taglineSpacing}px`,
		'--tagline-color': taglineColor,
		'--prefix-color': prefixColor,
	});

	return (
		<div {...useBlockProps.save()}>
			<div
				className={`templazee-separator align-${textAlign}`}
				style={{ display: "flex", justifyContent: textAlign, alignItems: "center", position: "relative" }}>
				<div
					className={`${separators}`}
					style={getStyles()}
				>
					{separators === 'style1' && <div className="center-part">
					</div>}

					{separators === 'style3' && <div className="left-part">
					</div>}
					{(separators === 'style7' || separators === 'style6') &&
						<span>
							<div className="beforeStyle" ></div>
							<div>{tagline && (taglineInput || "Tagline")}</div>
							<div className="afterStyle" ></div>
						</span>}

					{(separators === 'custom') &&
						<span>
							<div dangerouslySetInnerHTML={{ __html: svgInput }} />
						</span>}
				</div>
			</div>
		</div>
	);
}
